import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home.vue'
import VueMeta from 'vue-meta'

Vue.use(VueRouter)
Vue.use(VueMeta, {
	refreshOnceOnNavigation: true
})
  
const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/about',
		name: 'About',
		component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
	},
	{
		path: '/contacts',
		name: 'Contacts',
		component: () => import(/* webpackChunkName: "contacts" */ './views/Contacts.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior () {
		return { x: 0, y: 0 }
	}
})

router.afterEach((to) => {
	window.whitebox.init('analytics', analytics => {
		if (analytics) {
			setTimeout(() => {
				console.log('Track route:', to.path)
				analytics.service.info()
			}, 100)
		}
	})
})

export default router
